export const searchNothing = async () => [];
